import DomainListPanels from "./DomainListPanels";

export default DomainListPanels;
